export const AuthService = '/rest/physical/person/login';
export const Auth2faService = '/rest/physical/person/login2fa';
export const LogoutService = '/api/rest/auth/logout';
export const SessionService = '/rest/session';
export const SsoService = '/api/rest/auth/sso/login'
export const CareerBonusLogoutService = '/career-bonus/back/user/logout';
